import { defaultAxiosInstance } from "./defaultInstance";

export const fetchBlogAnalysisRegistry = async ({ keyword, indexTier, isInfluencer, isNaverMate, limit = 50, offset = 0 }) => {
  const params = { limit, offset };

  if (keyword) params.keyword = keyword;
  if (indexTier) params.indexTier = indexTier;
  if (isInfluencer !== undefined) params.isInfluencer = isInfluencer;
  if (isNaverMate !== undefined) params.isNaverMate = isNaverMate;

  const response = await defaultAxiosInstance.get("/admin/blog-analysis-registry", { params });
  return response.data;
};

export const fetchBlogAnalysisIndexTiers = async () => {
  const response = await defaultAxiosInstance.get("/admin/blog-analysis-registry/index-tiers");
  return response.data;
};
